import { useOutletContext } from "react-router-dom";
import Styles from "./InfoPage.module.scss";
import { Text } from "src/components/atoms/Text/Text";
import { LocationBlock } from "src/components/compounds/EventDetails/LocationBlock";
import { WeatherBlock } from "src/components/compounds/EventDetails/WeatherBlock";
import * as Team from "src/state/modules/team";
import * as Event from "src/state/modules/event";

type EventStatsPageProps = {
  team: Team.Team;
  event: Event.Event;
};

const NotesBlock = (event: Event.Event) => (
  <>
    <Text size={"base"} weight={"xbold"} block bottomMargin>
      Notes
    </Text>
    {event.notes ? (
      <Text className={Styles.eventNotes} size={"base"} block>
        {event.notes}
      </Text>
    ) : (
      <Text size={"base"} color={"cool-grey"} block>
        No notes
      </Text>
    )}
  </>
);

export default function InfoPage() {
  const { event } = useOutletContext<EventStatsPageProps>();
  const hasLocation = (event.addressParts?.length ?? 0) > 0;
  return (
    <div className={Styles.gridContainer}>
      <div className={Styles.layout}>
        <div className={Styles.card}>
          <NotesBlock {...event} />
          {hasLocation && <div className={Styles.cardDivider} />}
          <LocationBlock event={event} />
        </div>
        <WeatherBlock event={event} />
      </div>
    </div>
  );
}
